<template>
  <EuiBlock id="logs_mail" title="Nombre d'erreur d'envoi par mail sur les 60 derniers jours">
    <EuiHeading v-if="getterIsLoading " :level="4">En cours de chargement</EuiHeading>
    <span v-else-if="listInvalidMails.length === 0">Aucun résultat</span>
    <EuiAdvancedTable v-else v-model="listInvalidMails" >
      <EuiATableRow   slot="tableRow" slot-scope="{ item }" @click="selectMail(item)" >
        <EuiATableCell label="De">{{ item.key[0] }}</EuiATableCell>
        <EuiATableCell label="Nb d'erreur">{{ item.values[0].value }}</EuiATableCell>
      </EuiATableRow>
    </EuiAdvancedTable>
    <ConfirmationDialog
        :isOpen="isConfirmationDialogOpen"
        @confirmation="confirmation"
        @close-dialog="closeDialog">
      <span v-html="confirmationMessage"></span>
    </ConfirmationDialog>
  </EuiBlock>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmationDialog from '@/components/confirmationDialog.vue';

export default {
  name: 'components.mails.resultMails',
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      selectedMail: '',
      isConfirmationDialogOpen: false,
      listMailToHide: [
        'info@deskrh.fr',
        'contact@edoc.fr',
      ],
    };
  },
  methods: {
    selectMail(mail) {
      this.selectedMail = mail;
      this.isConfirmationDialogOpen = true;
    },
    closeDialog() {
      this.isConfirmationDialogOpen = false;
    },
    confirmation() {
      this.closeDialog();
      this.searchMail(this.selectedMail);
    },
    validation() {
      this.isConfirmationDialogOpen = true;
    },
    searchMail(mail) {
      if (this.selectedMail !== '') {
        this.$router.push({
          name: 'mails.search',
          params: { emailToSearch: mail.key[0] },
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      storeStartSearch: 'application/startSearch',
      getterResults: 'logs/result',
      getterIsLoading: 'application/isLoading',
    }),
    confirmationMessage() {
      if (this.selectedMail.key !== undefined && this.selectedMail.key[0]) {
        return `Lancer la recherche pour cet email <b>${this.selectedMail.key[0]}</b>?`;
      }
      return '';
    },
    /**
     * Return all invalids mails for graylog. The function concatenate the differents results from
     * each nodes, queries, search.
     * @returns {*[]}
     */
    listInvalidMails() {
      if (this.getterResults.results === undefined) {
        return [];
      }
      const AllInvalids = Object.keys(this.getterResults.results).reduce((accFinalResults, currentId) => {
        const search = Object.keys(this.getterResults.results[currentId].search_types);
        return search.reduce((acc, currentQuery) => {
          if (this.getterResults.results[currentId].search_types[currentQuery] !== undefined) {
            return acc.concat(this.getterResults.results[currentId].search_types[currentQuery].rows);
          }
          return acc;
        }, accFinalResults);
      }, []);
      return AllInvalids.filter(mail => !this.listMailToHide.includes(mail.key[0]));
    },
  },
};
</script>
